import React from 'react'
import Switch from 'react-switch'

import Icon from 'app/views/components/Icon'


const ContentSettings = ({
  handleToggleMustPassCodingExercise,
  mustPassCodingExercise,
  showAllTraining,
  showCodingChallenges,
  handleToggleShowAllTraining,
  handleToggleShowCodingChallenges,
}) => {
  if (mustPassCodingExercise === undefined) {
    return <div />
  }

  return (
    <div className="uk-card uk-card-default" style={{ maxWidth: 750 }}>
      <div className="uk-card-body">
        <div className="uk-inline">
          <Switch
            onChange={handleToggleMustPassCodingExercise}
            checked={mustPassCodingExercise}
            id="normal-switch"
            offColor="#999999"
            onColor="#1e87f0"
            checkedIcon={false}
            uncheckedIcon={false}
          />
          <span className="uk-margin-small-left uk-text-top">
            Coding Test Required
          </span>
          <Icon
            as="a"
            href="https://help.hackedu.com/en/articles/3121295-what-is-must-pass-coding-exercise"
            icon="question"
            ratio={0.8}
            style={{ marginLeft: 5, verticalAlign: 'top', display: 'inline-block' }}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
        <br />
        <br />
        <div className="uk-inline">
          <Switch
            onChange={handleToggleShowAllTraining}
            checked={showAllTraining}
            id="all-training-switch"
            data-test-id="show-all-training-switch"
            offColor="#999999"
            onColor="#1e87f0"
            checkedIcon={false}
            uncheckedIcon={false}
          />
          <span className="uk-margin-small-left uk-text-top">
            Show All Training
          </span>
          <Icon
            as="a"
            href="http://help.hackedu.com/en/articles/3364093-hide-all-training-in-navigation"
            name="question"
            ratio={0.8}
            style={{ marginLeft: 5, verticalAlign: 'top', display: 'inline-block' }}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
        <br />
        <br />
        <div className="uk-inline">
          <Switch
            onChange={handleToggleShowCodingChallenges}
            checked={showCodingChallenges}
            id="hide-code-review-switch"
            offColor="#999999"
            onColor="#1e87f0"
            checkedIcon={false}
            uncheckedIcon={false}
          />
          <span className="uk-margin-small-left uk-text-top">
            Show Coding Challenges
          </span>
          <Icon
            as="a"
            href="https://help.hackedu.com/en/articles/3949030-show-coding-challenges-setting"
            name="question"
            ratio={0.8}
            style={{ marginLeft: 5, verticalAlign: 'top', display: 'inline-block' }}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
      </div>
    </div>
  )
}

export default ContentSettings
